/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { AttachedCustomField$inboundSchema, AttachedCustomField$outboundSchema, } from "./attachedcustomfield.js";
import { Benefit$inboundSchema, Benefit$outboundSchema, } from "./benefit.js";
import { LegacyRecurringProductPrice$inboundSchema, LegacyRecurringProductPrice$outboundSchema, } from "./legacyrecurringproductprice.js";
import { ProductMediaFileRead$inboundSchema, ProductMediaFileRead$outboundSchema, } from "./productmediafileread.js";
import { ProductPrice$inboundSchema, ProductPrice$outboundSchema, } from "./productprice.js";
import { SubscriptionRecurringInterval$inboundSchema, SubscriptionRecurringInterval$outboundSchema, } from "./subscriptionrecurringinterval.js";
/** @internal */
export const ProductMetadata$inboundSchema = z.union([z.string(), z.number().int(), z.boolean()]);
/** @internal */
export const ProductMetadata$outboundSchema = z.union([z.string(), z.number().int(), z.boolean()]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var ProductMetadata$;
(function (ProductMetadata$) {
    /** @deprecated use `ProductMetadata$inboundSchema` instead. */
    ProductMetadata$.inboundSchema = ProductMetadata$inboundSchema;
    /** @deprecated use `ProductMetadata$outboundSchema` instead. */
    ProductMetadata$.outboundSchema = ProductMetadata$outboundSchema;
})(ProductMetadata$ || (ProductMetadata$ = {}));
export function productMetadataToJSON(productMetadata) {
    return JSON.stringify(ProductMetadata$outboundSchema.parse(productMetadata));
}
export function productMetadataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => ProductMetadata$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ProductMetadata' from JSON`);
}
/** @internal */
export const ProductPrices$inboundSchema = z.union([
    LegacyRecurringProductPrice$inboundSchema,
    ProductPrice$inboundSchema,
]);
/** @internal */
export const ProductPrices$outboundSchema = z.union([
    LegacyRecurringProductPrice$outboundSchema,
    ProductPrice$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var ProductPrices$;
(function (ProductPrices$) {
    /** @deprecated use `ProductPrices$inboundSchema` instead. */
    ProductPrices$.inboundSchema = ProductPrices$inboundSchema;
    /** @deprecated use `ProductPrices$outboundSchema` instead. */
    ProductPrices$.outboundSchema = ProductPrices$outboundSchema;
})(ProductPrices$ || (ProductPrices$ = {}));
export function productPricesToJSON(productPrices) {
    return JSON.stringify(ProductPrices$outboundSchema.parse(productPrices));
}
export function productPricesFromJSON(jsonString) {
    return safeParse(jsonString, (x) => ProductPrices$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ProductPrices' from JSON`);
}
/** @internal */
export const Product$inboundSchema = z.object({
    created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    modified_at: z.nullable(z.string().datetime({ offset: true }).transform(v => new Date(v))),
    id: z.string(),
    name: z.string(),
    description: z.nullable(z.string()),
    recurring_interval: z.nullable(SubscriptionRecurringInterval$inboundSchema),
    is_recurring: z.boolean(),
    is_archived: z.boolean(),
    organization_id: z.string(),
    metadata: z.record(z.union([z.string(), z.number().int(), z.boolean()])),
    prices: z.array(z.union([
        LegacyRecurringProductPrice$inboundSchema,
        ProductPrice$inboundSchema,
    ])),
    benefits: z.array(Benefit$inboundSchema),
    medias: z.array(ProductMediaFileRead$inboundSchema),
    attached_custom_fields: z.array(AttachedCustomField$inboundSchema),
}).transform((v) => {
    return remap$(v, {
        "created_at": "createdAt",
        "modified_at": "modifiedAt",
        "recurring_interval": "recurringInterval",
        "is_recurring": "isRecurring",
        "is_archived": "isArchived",
        "organization_id": "organizationId",
        "attached_custom_fields": "attachedCustomFields",
    });
});
/** @internal */
export const Product$outboundSchema = z.object({
    createdAt: z.date().transform(v => v.toISOString()),
    modifiedAt: z.nullable(z.date().transform(v => v.toISOString())),
    id: z.string(),
    name: z.string(),
    description: z.nullable(z.string()),
    recurringInterval: z.nullable(SubscriptionRecurringInterval$outboundSchema),
    isRecurring: z.boolean(),
    isArchived: z.boolean(),
    organizationId: z.string(),
    metadata: z.record(z.union([z.string(), z.number().int(), z.boolean()])),
    prices: z.array(z.union([
        LegacyRecurringProductPrice$outboundSchema,
        ProductPrice$outboundSchema,
    ])),
    benefits: z.array(Benefit$outboundSchema),
    medias: z.array(ProductMediaFileRead$outboundSchema),
    attachedCustomFields: z.array(AttachedCustomField$outboundSchema),
}).transform((v) => {
    return remap$(v, {
        createdAt: "created_at",
        modifiedAt: "modified_at",
        recurringInterval: "recurring_interval",
        isRecurring: "is_recurring",
        isArchived: "is_archived",
        organizationId: "organization_id",
        attachedCustomFields: "attached_custom_fields",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var Product$;
(function (Product$) {
    /** @deprecated use `Product$inboundSchema` instead. */
    Product$.inboundSchema = Product$inboundSchema;
    /** @deprecated use `Product$outboundSchema` instead. */
    Product$.outboundSchema = Product$outboundSchema;
})(Product$ || (Product$ = {}));
export function productToJSON(product) {
    return JSON.stringify(Product$outboundSchema.parse(product));
}
export function productFromJSON(jsonString) {
    return safeParse(jsonString, (x) => Product$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Product' from JSON`);
}
//# sourceMappingURL=product.js.map